<lib-performance-details
  [sustainmentId]="sustainmentId"
  [companyName]="companyName"
  [alias]="alias"
></lib-performance-details>
